import { getConfig } from "./../api/config";

const ConfigStorage = window.localStorage;
const ConfigVarName = "__configs";
const ConfigMaxAge = 86400000;

export async function getConfigCached(configName) {
    return await getConfigs(configName);
}

function checkConfigs(configName) {
    const storedConfigs = ConfigStorage.getItem(`${ConfigVarName}-${configName}`);

    let configsFound = false;
    if (storedConfigs) {
        const { "__expires": expiry, configs = {} } = JSON.parse(storedConfigs);
        const expiryDate = new Date().setTime(expiry);
        const currentDate = new Date().getTime();

        if (expiryDate - currentDate > 0) {
            configsFound = configs;
        }
    }

    return configsFound;
}

async function getConfigs(configName) {
    let configs = checkConfigs(configName);

    if (configs === false) {
        let configsResponse;
        try {
            configsResponse = await getConfig(configName);
        } catch (e) {
            configsResponse = false;
        }

        configs = {};
        if (configsResponse) {
            const expiry = new Date().getTime() + ConfigMaxAge;

            configs = configsResponse;

            ConfigStorage.setItem(`${ConfigVarName}-${configName}`, JSON.stringify({ "__expires": expiry, configs }));
        }
    }

    return configs;
}
